<template>
    <div :class="['accordion-item',{'accordion-item--open': isOpen}]">
        <div class="accordion-item__top" @click="toggleAccordion">
            <slot name="icon"></slot>
            <slot name="title"></slot>
        </div>
        <div ref="contentWrapper" class="accordion-item__content" :style="{ maxHeight: isOpen ? contentHeight + 'px' : '0' }">
            <div ref="content" class="richtext">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: false,
            contentHeight: 0
        };
    },
    methods: {
        toggleAccordion() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                // Wait for the DOM to update, then calculate content height
                this.$nextTick(() => {
                    const content = this.$refs.content;
                    this.contentHeight = content.clientHeight;
                });
            } else {
                this.contentHeight = 0; // Reset height when closing
            }
        }
    }
};
</script>